import React, { useState, useEffect } from 'react';
import { config } from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Link, Navigate, resolvePath } from "react-router-dom";
import EduMonthCombo from '../combos/EduMonthCombo';
import ShowAnnounceSimple from '../message/ShowAnnounceSimple';
import { Button } from 'primereact/button';
import ShowError from "../shared/ShowError";
import { Col, Form, Row } from 'react-bootstrap';

export default function Home(props) {
  const [redirectUrl, setRedirectUrl] = useState("");
  const [checkLogin, setCheckLogin] = useState(false);
  const [changePassVisible, setChangePassVisible] = useState(false);
  const [errorVisible, setErorVisible] = useState(false);
  const [gotoLogin, setGotoLogin] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  
  useEffect(() => {
    setCheckLogin(true);
    var loginDto = util.getTrustedUser();
    if(loginDto == null){
      setCheckLogin(false);
      setRedirectUrl("/login");
      return;
    }
    var params = {
      login: loginDto
    };
    var url = config.Server + `/user/check-password/equal-to-mobile`;
    console.log("url is>", url)
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        console.log("response is>", response)
        if (response.state === "ok") {
          response = response.data;
          setCheckLogin(false);
          if(response === true){
            setChangePassVisible(true);
          }
        }
        else {
          util.clearCurrentUser(); 
          setErrorMessage(response.message);
          setErorVisible(true);
          setCheckLogin(false);
          setGotoLogin(true);
        }
      })
      .catch(error => {
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
        setCheckLogin(false);
      });
  }, []);

  const onMenuClick = function(url){
    setRedirectUrl(url);
  }
  const crateeBackup = function(){
    var url = config.Server+`/basic/create-backup-2030`;
      axios
          .get(url)
          .then(res => {
              var response = res.data;
              console.log("save response is>", response);
              if(response.state === "ok"){
                  alert("ok")               
              }
              else{
                  console.log("error is>", response.message);
                  alert("error")
              }
          })
          .catch(error => {
            console.log("error is>", error);
            alert("error")
          });

  }
  const createHomeIcons = function(){
    var user = util.getCurrentUser();
    var menus = []
    if(user.Role === 1){//ادمین
      menus = [
        {url:"/create-backup", icon:require("../lib/images/timing_icon.png"), text:"ایجاد نسخه پشتیبان"},
//        {url:"/restore-backup", icon:require("../lib/images/present_absent_icon.png"), text:"حضو و غیاب"},
      ]
      return(
        menus.map((menu)=>{
          return(
            <div onClick={() => {crateeBackup()}} className={"home_icon"}>
              <img src={menu.icon} style={{width:"96px", height:"96px", position:"absolute", top:"5px", left:"25px"}} />
              <div style={{position:"absolute", top:"120px", left:"0px", width:"100%", textAlign:"center", fontSize:"14pt"}}>{menu.text}</div>
            </div>
          )
        })
      )
    }
    else if(user.Role === 2 || user.Role === 3){//مدیر یا معاون مدرسه
      menus = [
        {url:"/school/timing", icon:require("../lib/images/timing_icon.png"), text:"برنامه هفتگی"},
        {url:"/school/present-absent", icon:require("../lib/images/present_absent_icon.png"), text:"حضو و غیاب"},
        {url:"/school/disiplin-notebook", icon:require("../lib/images/disipline-book.png"), text:"دفتر انضباط"},
        {url:"/school/absent-student/report", icon:require("../lib/images/absent-report-icon.png"), text:"گزارش غیبت"},
        {url:"/school/disipline-scores", icon:require("../lib/images/exam_icon.png"), text:"ثبت انضباط ماهانه"},
        {url:"/school/student", icon:require("../lib/images/persons_icon.png"), text:"دانش آموزان"},
        {url:"/school/user", icon:require("../lib/images/employees_icon.png"), text:"همکاران"},
        {url:"/school/class", icon:require("../lib/images/class_icon.png"), text:"کلاس ها"},
        {url:"/school/class/student", icon:require("../lib/images/grouping_icon.png"), text:"کلاس بندی دانش آموزان"},
        {url:"/school/send-sms/classes", icon:require("../lib/images/sms-icon.png"), text:"ارسال گروهی پیامک"},
        {url:"/school/send-sms/single", icon:require("../lib/images/sms-icon.png"), text:"ارسال پیامک"},
        {url:"/school/mobile-smses/list", icon:require("../lib/images/mobile-sms-icon.png"), text:"پیامک های آماده ارسال"},
        //{url:"/school/sms/charge", icon:require("../lib/images/charge-icon.png"), text:"شارژ پیامک"},
        {url:"/school/grade-sheet/create", icon:require("../lib/images/gradesheet-icon.png"), text:"ایجاد کارنامه ها"},
        {url:"/school/grade-sheet/print", icon:require("../lib/images/print-icon.png"), text:"چاپ کارنامه"},
        {url:"/school/analytic-chart", icon:require("../lib/images/chart-icon.png"), text:"نمودار های تحلیلی"},
        {url:"/school/announce-simple", icon:require("../lib/images/announce-icon.png"), text:"اطلاعیه"},
        {url:"/sms-sender/download", icon:require("../lib/images/sms-apk-icon.png"), text:"اپلیکیشن ارسال پیامک"},
        {url:"/sida/extenssion", icon:require("../lib/images/chrome-icon.png"), text:"افزونه سیدا"},
        {url:"/school/grade-sheet/visibility/set", icon:require("../lib/images/on-off-icon.png"), text:"تنظیم مشاهده کارنامه"},
      ]
    }
    else if(user.Role === 4){//معلم
      menus = [
        {url:"/teacher/timing", icon:require("../lib/images/timing_icon.png"), text:"برنامه هفتگی"},
        {url:"/teacher/present-absent", icon:require("../lib/images/present_absent_icon.png"), text:"حضو و غیاب"},
        {url:"/teacher/exams", icon:require("../lib/images/exam_icon.png"), text:"نمرات آزمون ها"},
        {url:"/teacher/final-scores", icon:require("../lib/images/exam_icon.png"), text:"نمرات نهائی ماه"},
        {url:"/teacher/notes", icon:require("../lib/images/note-icon.png"), text:"یادداشت های کلاسی"},
        {url:"/message/announce-simple", icon:require("../lib/images/announce-icon.png"), text:"اطلاعیه"},
        {url:"/teacher/history/present-absent", icon:require("../lib/images/review-icon.png"), text:"تاریخچه حضور و غیاب"},
      ]
    }
    else if((user.Role === 5)/*دانش آموز*/||(user.Role === 6)/*ولی*/){
      menus = [
        {url:"/student/timing", icon:require("../lib/images/timing_icon.png"), text:"برنامه هفتگی"},
        {url:"/student/grade-sheet/disorder", icon:require("../lib/images/disipline-book.png"), text:"کارنامه تربیتی"},
        // {url:"/student/grade-sheet/continual", icon:require("../lib/images/exam_icon.png"), text:"کارنامه مستمر"},
        {url:"/student/scores", icon:require("../lib/images/exam_icon.png"), text:"نمرات آزمون ها"},
        {url:"/message/announce-simple", icon:require("../lib/images/announce-icon.png"), text:"اطلاعیه"},
        {url:"/student/grade-sheet/print", icon:require("../lib/images/print-icon.png"), text:"چاپ کارنامه"},
      ]
    }
    else if(user.Role === 7){//نماینده فروش
      menus = [
        {url:"/school/list", icon:require("../lib/images/list-icon.png"), text:"لیست مدارس"},
        {url:"/school/set-active", icon:require("../lib/images/active-inactive-icon.png"), text:"تغیر وضعیت مدرسه"},
        {url:"/membership/request/list", icon:require("../lib/images/gradesheet-icon.png"), text:"درخواست های عضویت"},
      ]
    }
    return(
      menus.map((menu)=>{
        return(
          <div onClick={() => {onMenuClick(menu.url)}} className={"home_icon"}>
            <img src={menu.icon} style={{width:"64px", height:"64px", position:"absolute", top:"5px", left:"20px"}} />
            <div style={{position:"absolute", bottom:"10px", left:"0px", width:"100%", textAlign:"center", fontSize:"11pt"}}>{menu.text}</div>
          </div>
        )
      })
    )
  }

  return(
    (redirectUrl != "")
    ?
    <Navigate to={redirectUrl} replace={false}  />
    :
    <>
    {
      checkLogin?
      <>check login...</>
      :
      gotoLogin?
      <>
        <div style={{margin:"10px 0px"}}>
              <div className="justify-content-center" style={{ direction: "rtl" }}>
                <Button label="ورود به سامانه" icon="pi pi-check" onClick={() => {setRedirectUrl("/login");}}  severity="success" iconPos="right" style={{maxWidth:"200px"}} />
              </div>
        </div>
      </>
      :
      changePassVisible?
      <>
        <div style={{backgroundColor:"#ce5c5cff", color:"#fff", width:"calc(100% - 10px)", padding:"5px", borderRadius:"5px", margin:"10px 0px"}}>
          کلمه عبور شما در حال حاضر شماره موبایل شما می باشد و شما باید آنرا تغیر دهید.
          <br/>
          در صورتی که آنرا تغیر ندهید بزودی حساب کاربری شما غیر فعال می گردد
          <br/>
          <br/>
          <Row>
            <Col md={3}> 
              <div style={{margin:"10px 0px"}}>
                  <React.Fragment>
                    <div className="card flex justify-content-center" style={{ direction: "ltr" }}>
                      <Button label="تغیر کلمه عبور" icon="pi pi-check" onClick={() => setRedirectUrl("/change-password")}  severity="success" iconPos="right" />
                    </div>
                  </React.Fragment>          
              </div>
            </Col>
          </Row>
        </div>

      </>
      :
      <>
        <ShowAnnounceSimple onlyShowNew={true} />
        {createHomeIcons()}
      </>
    }
      <ShowError visible={errorVisible} message={errorMessage} closeError={() => { setErorVisible(false) }} />
    </>  
  );
}